import React, { createContext } from "react";

import { ReturnType } from "fond/hooks/useFilterLayers";

export const LayerFilterContext = createContext<ReturnType>(undefined!);
